import { MatDividerModule } from '@angular/material/divider';
import { DividerTypeComponent } from './divider-type.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';

@NgModule({
  declarations: [DividerTypeComponent],
  imports: [
    CommonModule,
    MatDividerModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'divider',
          component: DividerTypeComponent,
          defaultOptions: {
            className: 'd-block my-2',
          },
        },
      ],
    }),
  ],
})
export class DividerTypeModule {}
